<app-pageheader [Parent]="this">
</app-pageheader>
<app-loader [Parent]="this"></app-loader>

<div class="columns">
  <div class="column is-6">
    <article class="panel">
      <p class="panel-heading">Select Workflow Step</p>
      <div class="panel-block" [class.is-loading]="IsLoading" style="min-height: 100px; display: flex; align-items: center; justify-content: center;">
        @if (availableSteps.length > 0) {
          <div style="width: 100%;">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Step</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select [(ngModel)]="selectedStepId" (change)="onStepSelected($event)">
                        <option [ngValue]="null" disabled>Select a step...</option>
                        @for (step of availableSteps; track step) {
                          <option [value]="step.Id">{{step.Name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        @if (availableSteps.length == 0) {
          <div class="has-text-centered has-text-grey has-text-italic">
            No steps configured for users to action.
          </div>
        }
      </div>
    </article>
  </div>

  <div class="column is-6">
    @if (citations.length > 0) {
      <article class="panel">
        <p class="panel-heading">Bulk Actions</p>
        <div class="panel-block">
          <div class="field">
            <div class="control">
              <button class="button is-primary" (click)="actionSelectedCitations()" [disabled]="selectedCitations.size === 0">
                Action Selected Citations
              </button>
            </div>
          </div>
        </div>
      </article>
    }
  </div>
</div>

<div class="columns">
  <div class="column is-12">
    <article class="panel">
      <p class="panel-heading">Citations Requiring Action</p>
      <div class="panel-block" [class.is-loading]="IsLoading" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
        @if (!selectedStepId) {
          <div class="has-text-centered has-text-grey has-text-italic">
            Select a step to filter citations
          </div>
        }
        @if (selectedStepId && citations.length > 0) {
          <div class="table-container" style="width: 100%;">
            <table class="table is-striped is-bordered is-fullwidth">
              <thead>
                <tr>
                  <th>
                    <label class="checkbox">
                      <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
                    </label>
                  </th>
                  <th>Reference</th>
                  <th>Status</th>
                  <th class="has-text-right">Issued Date</th>
                </tr>
              </thead>
              <tbody>
                @for (citation of citations; track citation) {
                  <tr>
                    <td>
                      <label class="checkbox">
                        <input type="checkbox" [checked]="isCitationSelected(citation.Id)" (change)="toggleCitationSelection(citation.Id)">
                      </label>
                    </td>
                    <td>{{citation.Reference}}</td>
                    <td>{{citation.Status}}</td>
                    <td class="has-text-right">{{citation.IssuedDateLocalFriendlyString}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @if (selectedStepId && citations.length === 0) {
          <div class="has-text-centered has-text-grey has-text-italic">
            No citations to action in {{getSelectedStepName()}}
          </div>
        }
      </div>
    </article>
  </div>
</div>